import { IStoryGameState } from "../reducers/storyGameReducer";

export default (state: { storyGame: IStoryGameState}) => {
  return state.storyGame;
};
